import { render, staticRenderFns } from "./BCXSidebarOrLayer.vue?vue&type=template&id=c5f9fbea"
import script from "./BCXSidebarOrLayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXSidebarOrLayer.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports